module.exports = __webpack_public_path__ + "static/cover-afe1561c5548cdf62f39f1e53d75300b.jpg";